//-------------------------------------------------------------------------------------------------- Imports
import { createSlice } from "@reduxjs/toolkit";

//-------------------------------------------------------------------------------------------------- Slice
export const bannerSlice = createSlice({
    name: 'banners',
    initialState: {
        "banners": undefined,
    },
    reducers: {
        setBanners: (state, action) => {
            return action.payload;
        },
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export const { setBanners } = bannerSlice.actions;
export default bannerSlice.reducer;